module.exports = __webpack_public_path__ + "static/media/gCash.701031a1.png";